const isStaff = (user: any) => {
  if (user?.roles?.includes('user') && ['Staff', 'Teachers'].indexOf(user?.groupPermission?.name) !== -1) {
    return true;
  }
  return false;
};

export default isStaff;
